
import React, { useState } from "react";
import LogoApp from "../../img/logo.png";
import { Box } from "@mui/material";


const ReusableHeader = () => {

    return (
        <nav className="navbar navbar-light border pb-0">
            <Box className="container-fluid">
                <a className="navbar-brand w-25" href="https://brands.groovenexus.com/">
                    <img src={LogoApp} alt="logo" className='w-50' />
                </a>
            </Box>
        </nav>
    );
};

export default ReusableHeader;
